import * as React from 'react'
export const Ch = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 513 342" width="1em" height="1em" {...props}>
    <path fill="red" d="M0 85.337h513v342H0z" />
    <path
      fill="#FFF"
      d="M356.174 222.609h-66.783v-66.783h-66.782v66.783h-66.783v66.782h66.783v66.783h66.782v-66.783h66.783z"
    />
  </svg>
)
